import { RoleName } from '../enums';

export const EventAdminRequiredRoles: RoleName[] = [
	RoleName.Admin,
	RoleName.EventAdmin,
];